<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap">
      <section class="boss-contractperiod-container">
        <!-- ▼掲載期間見出し -->
        <scout-and-like-period-bar
          v-if="!!contract"
          :first-date="contract.firstDate"
          :last-date="contract.lastDate"
          :scout-limit="contract.scoutLimit"
          :sent-scout-amount="contract.sentScoutAmount"
          :like-limit="contract.likeLimit"
          :sent-like-amount="contract.sentLikeAmount"
          :reserved-scout-first-send-amount="contract.reservedScoutFirstSendAmount"
        />
        <div
          v-else
          class="boss-agreement-headline-container clearfix"
        >
          <div class="boss-agreement-headline-wrap" />
        </div>
        <!-- ▲掲載期間見出し -->
        <div class="boss-contractperiod-wrap">
          <!-- ▼求人掲載中 container -->
          <div class="boss-posting-container">
            <div class="boss-posting-wrap boss-main-content-wrap">
              <div
                v-if="isShowJobLabel"
                class="boss-pulldown-container boss-published"
              >
                <label
                  class="boss-pulldown-menu"
                  for="boss-published-item"
                >
                  <select
                    id="boss-published-item"
                    class="boss-pulldown-menu-item"
                    data-test="job-pulldown"
                    disabled
                  >
                    <option>求人ID: {{ job.id }} {{ job.name }}</option>
                  </select>
                </label>
              </div>
              <router-view />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ScoutAndLikePeriodBar from '@/components/molecules/ScoutandLikePeriodBar'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { ScoutAndLikePeriodBar },
  computed: {
    ...mapGetters('contracts', {
      publishedContracts: 'publishedContracts',
      jobBy: 'jobBy'
    }),
    contract () {
      return this.publishedContracts[0]
    },
    isShowJobLabel () {
      // いいね自動送信設定一覧画面では求人プルダウンを表示しない状態にしたいため、isShowJobLabelをfalseで渡す。
      return this.$route.name !== 'settingAutoLikedTop'
    },
    job () {
      return this.jobBy(this.contract.id, this.$route.params.jobId)
    }
  },
  created () {
    this.storeContracts()
  },
  methods: {
    ...mapActions('contracts', [
      'storeContracts'
    ])
  }
}
</script>
